import Header from '@components/Header';
import styled from '@emotion/styled';
import useItem from '@hooks/item/useItem';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { ItemActivityIdProvider } from '@store/item/context/ItemActivityContext';
import { useTranslation } from 'react-i18next';

import TextOption from '../_shared/components/TextOption';

interface Params {
    itemId: string;
    itemActivityId: string;
}

declare module '@stackflow/config' {
    interface Register {
        PersonalOptionActivity: Params;
    }
}

const PersonalOptionActivity: ActivityComponentType<'PersonalOptionActivity'> = ({ params }) => {
    const { itemId, itemActivityId } = params;
    const item = useItem(itemId);
    const { t } = useTranslation('item');
    return (
        <ItemActivityIdProvider value={itemActivityId}>
            <AppScreen>
                <Header title={t('option.personal')} />
                <Contents>
                    {item?.personalOptionGroups.map((optionGroup, idx) => (
                        <TextOption
                            optionType='personal'
                            optionGroup={optionGroup}
                            noDivider={idx === 0}
                            key={optionGroup.optionGroupId}
                            itemId={itemId} />
                    ))}
                </Contents>
            </AppScreen>
        </ItemActivityIdProvider>
    );
};

const Contents = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 48px;
`;

export default PersonalOptionActivity;
